import { BLOCKS } from "@contentful/rich-text-types"

export const noParagraphTags = {
  [BLOCKS.PARAGRAPH]: (_, children) => children
}
